// Two jquery signs ($ and $) (version conflict)
import $ from 'jquery';
import selectric from 'selectric';
import { DataTables } from 'datatables';
import { loader } from './../layout/loader';
import { makeRequest } from './../layout/request';

import {
getInputNameAndValue,
reDrawTableOnFilterInputEvent,
setCheckboxOn,
setCheckboxOff,
handleCheckboxesOn,
handleCheckboxesOff,
getAllRowsFromArray,
checkArraySize,
hideOptions,
showOptions,
setToActive,
fakeScroll,
movePagination,
moveEmptyPlaceholders,
setEmptyPlaceholder,
refreshEmptyPlaceholder,
setSelectedWithShift
} from './datatables-helpers';

const datatablesArr = {};

/**
 * Inicjalizuje dataTablesListing
 * @param {string} identifier - identyfikator tabeli do zainicjalizowania
 */
function dataTablesListing(identifier) {
    console.log(identifier);
    // Init Values
    const currentListing = `#listing_table_${identifier}`,
            searchItem = `#listing_filters_${identifier}`,
            showSelect = `#listing_show_${identifier}`,
            url = $(currentListing).data('ajaxsource'),
            initValues = $(currentListing).data('payload');

    let idsArray = []; // Array with ids. Used for caching selected rows
    // Default settings for Selectric and DataTables
    var setSelectricWithEvents = function (table, select) {
        // Selectric Options
        const options = {
            arrowButtonMarkup: '<span class="select-button"></span>',
            maxHeight: 225,
            responsive: true,
            onChange: function () {
                table.page.len($(select).val())
            }
        };
        return $(select).selectric(options);
    };
    let defaultValues = {
        "bFilter": false,
        "bLengthChange": false,
        "bInfo": false,
        "processing": false,   // turn on processing loader display when data is loaded/processed
        "serverSide": true,   // turn on ajax source
        "searching": false,
        "searchDelay": 5000,
        // "scrollY":        "200px",
        // "scrollCollapse": true,
        // "paging":         true,
        ajax: {             // ajax options
            url: url,
            data: function (data) {
                // Process ajax data before send request to server:
                $(searchItem).find('input, select').each(function (index, input) {
                    var res = getInputNameAndValue(input);
                    if (res.value !== null) {
                        data[ res.name ] = res.value;
                    }
                });
                return data;
            },
            error: function (xhr, textStatus, error) {
                if (xhr.status === 401) {
                    // Reload current window if response status is 401 (Unauthorized), event fired in AjaxAuthenticationListener when user session is expired
                    window.location.reload();
                }
            }
        },
        drawCallback: function (settings) {
            let $selectAllButton = $('.js-select-dt-all');
            // Process html after re-draw table:
            if (Math.ceil((this.fnSettings().fnRecordsDisplay()) / this.fnSettings()._iDisplayLength) > 1) {
                $('#' + identifier + '_paginate').show();
            } else {
                $('#' + identifier + '_paginate').hide();
            }
            // Clear all selections and idsArray
            if($selectAllButton.length) {
                $selectAllButton.closest('th').removeClass('selected-all-rows');
                setCheckboxOff($selectAllButton);
                idsArray = [];
            }

            refreshEmptyPlaceholder();
            // movePagination();

        },
        createdRow: function (row, data, dataIndex) {
            if (typeof data._isAjax !== 'undefined' && data._isAjax) {
                // Process single <tr> for ajax call, after table row is added to add custom td html:
                $('>', row).each(function (index, originalTd) {
                    var $td = $(data[index]);
                    var $originalTd = $(originalTd);
                    // Copy all attributes:
                    $.each($td.prop('attributes'), function () {
                        $originalTd.attr(this.name, this.value);
                    });
                    $originalTd.html($td.html());
                });
            }
        },
        initComplete: function () {
            setEmptyPlaceholder();
        }
    };

    //Extends DataTables jquery object connected with styles namespace
    $.extend($.fn.dataTableExt.oStdClasses, {
        "sWrapper": 'table-wrap',
        "sLength": 'table-length',
        "sLengthSelect": 'table-length__select',
        "sFilter": 'table-search',
        "sFilterInput": 'table-search__input',
        "sPaging": 'pagination table-pagination ',
        "sInfo": 'table-info',
        "sPageButton": 'pagination__btn',
        "sProcessing": 'table-processing'
    });

    // Join initValues(from data-payload) and defaultValues into full DataTables init configuration
    const fullConfiguration = $.extend(initValues, defaultValues);

    //Initialize DataTables on currentListing with fullConfiguration object
    let table = $(currentListing).DataTable(fullConfiguration);

    setToActive(`listing_table_${identifier}`);

    //// Reloads DataTable instance after first load. BUG ( DataTables doesnt
    //table.ajax.reload(null, false);
    
    // Debounce function. Delays searching and pass search data to datatablaes instance
    let debounceSearch = $.fn.dataTable.util.throttle(function (val, searchBar) {
        table.search(val).draw();
    }, 300);

    // /Redraws table instance after changing select value
    table.on('length.dt', function (e, settings, len) {
        table.draw();
    });

    // table.on( 'processing.dt', function ( e, settings, processing ) {
    //     console.log('show');
    //     loader.show();

    //     if (!processing) {
    //         console.log('hide'); 
    //         loader.hide();
    //     };
    // } )

    // Pass data from custom searchbar to datatables
    $(searchItem).find('input[type=search]').on('keyup', function () {
        debounceSearch($(this).val(), $(this));
    });
    // Selectric init with event attached
    setSelectricWithEvents(table, showSelect);

    // Redraws table instance after changing connected datepicker's date (not used in default datatable)
    $(searchItem).find('.datepicker').on('dp.change', function () {
        reDrawTableOnFilterInputEvent(this, table);
    });

    // checkbox handlers
    table.on('click', '.js-select-dt-row', function (e) {
        e.stopPropagation();
        // prevent from firing click twice
        let parentRow = $(this).closest('tr');
        let id = $(this).data('id');
        if (e.target.tagName.toUpperCase() === "DIV") {
            return;
        }
        parentRow.toggleClass('selected-row');
        if (parentRow.hasClass('selected-row')) {
            $(this).prop('checked', true).attr('checked', 'checked');
            (function () {
                // check if element already exists in array
                var i = idsArray.indexOf(id);
                if (i < 0) {
                    idsArray.push(id);
                }
                checkArraySize(idsArray);
            })();
            setSelectedWithShift(e);
        } else {
            $(this).prop('checked', false).attr('checked', false);
            (function (e) {
                var i = idsArray.indexOf(id);
                if (i != -1) {
                    idsArray.splice(i, 1);
                }
                checkArraySize(idsArray);
            })()
        }
        fakeScroll();
    });
    //
    table.on('click', '.js-select-dt-all', function (e) {
        e.stopPropagation();
        // prevent from firing click twice
        if (e.target.tagName.toUpperCase() === "DIV") {
            return;
        }

        let allTableCheckboxes = $(currentListing).find('.js-select-dt-row');
        $(this).closest('th').toggleClass('selected-all-rows');

        if ($(this).closest('th').hasClass('selected-all-rows')) {
            $.each(allTableCheckboxes, function (id) {
                let $element = $(allTableCheckboxes[id]);
                let dataID = $element.data('id');
                // check if element already exists in array
                var i = idsArray.indexOf(dataID);
                if (i == -1) {
                    handleCheckboxesOn($element);
                    idsArray.push(dataID);
                }
            });
            checkArraySize(idsArray);
        } else {
            $.each(allTableCheckboxes, function (id) {
                handleCheckboxesOff($(allTableCheckboxes[id]), idsArray);
            });
            idsArray = [];
            checkArraySize(idsArray);
        }
    });

    table.on('click', '.js-dt-row-delete', function (e) {
        e.preventDefault();
        const deleteButton = $(this), data = deleteButton.data('path');
        $.ajax({
            type: "DELETE",
            url: data,
            success: function (data) {
                deleteButton.closest('tr').remove();
            }
        })
    });

    table.on('click', '.flipswitch__check', function (e) {
        e.preventDefault();
        var $element = $(this);
        let path = $(this).data('path');
        $.ajax({
            type: "PATCH",
            url: path,
            success: function (data) {
                if($element.prop('checked')) {
                    setCheckboxOff($element);
                } else {
                    setCheckboxOn($element);

                }
            }
        })
    });

    $('.js-delete-all-elements').on('click', function () {
        var formData = new FormData();
        var url = $(this).data('path');
        formData.append('ids', idsArray);
        let arrayOfSelectedElements = getAllRowsFromArray(idsArray, identifier);
        $.ajax({
            url: url,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function (data) {
                $.each(arrayOfSelectedElements, function (element) {
                    let currentRow = arrayOfSelectedElements[element]
                    currentRow.remove();
                });
            }
        })
    });

    $('.js-share-all-elements').on('click', function () {
        var formData = new FormData();
        var url = $(this).data('path');
        formData.append('ids', idsArray);
        let arrayOfSelectedElements = getAllRowsFromArray(idsArray, identifier);
        $.ajax({
            url: url,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function (data) {
                $.each(arrayOfSelectedElements, function (element) {
                    let currentRow = arrayOfSelectedElements[element], connectedSwitch = currentRow.find('.flipswitch__check');
                    handleCheckboxesOn(connectedSwitch);
                });
            }
        })
    });

    $('.js-unshare-all-elements').on('click', function () {
        let formData = new FormData();
        const url = $(this).data('path');
        let arrayOfSelectedElements = getAllRowsFromArray(idsArray, identifier);
        formData.append('ids', idsArray);
        $.ajax({
            url: url,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function (data) {
                $.each(arrayOfSelectedElements, function (element) {
                    let currentRow = arrayOfSelectedElements[ element ], connectedSwitch = currentRow.find('.flipswitch__check');
                    handleCheckboxesOff(connectedSwitch);
                });
            }
        })
    });

    // save datatables to global array
    datatablesArr[identifier] = table;
}

function getAllDataTableListings() {
    const table = [];
    const allTables = $("table[id^='listing_table_']");

    // Iterate to get all table id's
    $.each(allTables, function () {
        const tableName = $(this).data('tablename');
        table.push(tableName);
    });

    return table;
}

function setAllDataTableListings() {
    const tableOfDataTables = getAllDataTableListings();
    if (tableOfDataTables.length < 0) return false;
    for (let i = 0; i < tableOfDataTables.length; i++) {
        dataTablesListing(tableOfDataTables[i]);
    }
}

function init() {
    
    setAllDataTableListings();

}

export { init, dataTablesListing, datatablesArr };



// WEBPACK FOOTER //
// ./src/_app/components/datatables.js